import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  orderCancelAndRefundWithCardInvoluntaryFlow,
  orderEligibilitiesMockEligibleToRefundTypeInvoluntaryUsingCard,
  orderWithInvolutaryRefundEligibleRoundTripDisruptedUsingCard,
} from '../../../mock/data/index';
import {
  servicesNotRefundableWarning,
} from '../../../mock/dictionaries';

export const notEligibleToSelfReaccAndRecoveryPageRefundMock: MockMap = {
  retrieveOrder: [createMockData(orderWithInvolutaryRefundEligibleRoundTripDisruptedUsingCard)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundTypeInvoluntaryUsingCard, [], [servicesNotRefundableWarning])],
  cancelAndRefundOrder: [createMockDataWithResponse(orderCancelAndRefundWithCardInvoluntaryFlow, 201)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
